export default __webpack_public_path__ + "static/media/iphone.12db58b9.svg";